export default "__VITE_ASSET__ngRLmP7n__"